import {useEffect, useState} from 'react'
import {LoadingSpinner} from '../../../../../utils/loading/loadingSpinner'
import {getPaymentOption} from '../../../../sales/create/core/_request'
import {ISelectPaymentOption} from '../../../../../coreGlobal/models/default'
import {useFranchiseTransferCart} from '../core/FranchiseTransferProvider'
import {KTIcon} from '../../../../../_metronic/helpers'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'
import {getPaymentOptionTransfer} from '../core/_request'
import {PageOverlayer} from '../../../../../components/PageOverlayer'
import Swal from 'sweetalert2'

const AUTOMATIC_PAYMENTS = [1, 2, 3, 4]

const methodSize = (length, index) => {
  if (index == 0 && length === 1) {
    return 'col-10 p-0'
  }

  if (index == 0 && length != 0) {
    return 'col-12 p-0'
  }

  if (index != 0 && index < length - 1) {
    return 'col-10 p-0'
  }

  return 'col-7 p-0'
}
const SwitchAction = ({position, length, addMethodPayment, removeMethodPayment}) => {
  if (position === 1 && length > 1) return <></>
  if (position == 1 && length == 1) {
    return (
      <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
        <span
          onClick={() => addMethodPayment('DESTINATION')}
          className='btn btn-light-danger font-weight-bold w-auto'
        >
          <KTIcon iconName='plus' className='svg-icon svg-icon-danger' />
        </span>
      </div>
    )
  }

  if (position !== 0 && position !== length) {
    return (
      <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
        <span
          onClick={() => removeMethodPayment()}
          className='btn btn-light-danger font-weight-bold w-auto'
        >
          <KTIcon iconName='trash' className='svg-icon svg-icon-danger' />
        </span>
      </div>
    )
  }

  if (position !== 0 && position === length) {
    return (
      <>
        <div className='col-2 p-0 ms-2 me-2 d-flex align-items-center justify-content-center '>
          <span
            onClick={() => addMethodPayment('DESTINATION')}
            className='btn btn-light-danger font-weight-bold w-auto'
          >
            <KTIcon iconName='plus' className='svg-icon svg-icon-danger' />
          </span>
        </div>
        <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
          <span
            onClick={() => removeMethodPayment()}
            className='btn btn-light-danger font-weight-bold w-auto'
          >
            <KTIcon iconName='trash' className='svg-icon svg-icon-danger' />
          </span>
        </div>
      </>
    )
  }

  return <></>
}
export const PaymentRecurrentClientDestination = () => {
  const [paymentOption, setStates] = useState<ISelectPaymentOption[] | undefined>([])
  const [loadingPage, setLoadingPage] = useState(false)
  const [optionInstallment, setOptionInstallment] = useState<any>()
  const {franchiseDestination} = useFranchiseTransferCart()

  useEffect(() => {
    async function init() {
      try {
        setLoadingPage(true)
        const data = await getPaymentOptionTransfer(String(franchiseDestination))
        const dataFilter = data?.filter((val) => {
          return val.value != '5'
        })

        setStates(dataFilter)
      } catch (error: any) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      } finally {
        setLoadingPage(false)
      }
    }

    init()
  }, [])
  const {
    billingDestination,
    setBillingDestination,
    addMethodPaymentBilling,
    removeMethodPaymentBilling,
    handleChangeTypeMethodPaymentBilling,
    handleChangeValueMethodPaymentBilling,
    handleChangeInstallmentsBilling,
  } = useFranchiseTransferCart()

  useEffect(() => {
    if (!paymentOption?.length) return

    const available = paymentOption.map((option) => Number(option.value))
    if (billingDestination.every((pay) => available.includes(Number(pay.method)))) return

    const firstOption =
      paymentOption.find((option) => AUTOMATIC_PAYMENTS.includes(Number(option.value))) ??
      paymentOption[0]
    const method = Number(firstOption.value)
    const recurrency = method === 3
    const installmentEnabled = Boolean(firstOption.installment_enabled)

    if (installmentEnabled) {
      setOptionInstallment(
        Array.from({length: Number(firstOption.numberInstallment)}, (_, i) => i + 1)
      )
    }

    setBillingDestination((prev) =>
      prev.map((pay) =>
        available.includes(Number(pay.method))
          ? pay
          : {
              ...pay,
              method,
              recurrency,
              hasInstallment: installmentEnabled,
              ...(recurrency && {installments: 2}),
            }
      )
    )
  }, [paymentOption, billingDestination])

  const hasInstallment = (id, index, e) => {
    const data = paymentOption?.find((val) => {
      return val.value == id && val.installment_enabled == true
    })

    if (data !== undefined) {
      handleChangeTypeMethodPaymentBilling(index, e, true, 'DESTINATION')
      const installmentsArray = Array.from(
        {length: Number(data?.numberInstallment)},
        (_, i) => i + 1
      )
      setOptionInstallment(installmentsArray)
      return
    }

    handleChangeTypeMethodPaymentBilling(index, e, false, 'DESTINATION')
  }

  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        billingDestination?.map((pay, index) => {
          const billingMethodSize = methodSize(billingDestination.length, index)

          return (
            <div className='mb-8 w-100'>
              <label>{index + 1}. Forma:</label>
              <div className='row m-0 col-12'>
                <div className={billingMethodSize}>
                  <select
                    className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                    value={pay.method}
                    onChange={(e) => {
                      hasInstallment(e.target.value, index, e)
                    }}
                  >
                    {paymentOption?.some((option) =>
                      AUTOMATIC_PAYMENTS.includes(Number(option.value))
                    ) && (
                      <optgroup label='Automáticos:'>
                        {paymentOption
                          ?.filter((option) => AUTOMATIC_PAYMENTS.includes(Number(option.value)))
                          ?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </optgroup>
                    )}

                    {paymentOption?.some(
                      (option) => !AUTOMATIC_PAYMENTS.includes(Number(option.value))
                    ) && (
                      <optgroup label='Manuais:'>
                        {paymentOption
                          ?.filter((option) => !AUTOMATIC_PAYMENTS.includes(Number(option.value)))
                          ?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </optgroup>
                    )}
                  </select>
                </div>
                <SwitchAction
                  position={index + 1}
                  length={billingDestination.length}
                  addMethodPayment={addMethodPaymentBilling}
                  removeMethodPayment={() => {
                    removeMethodPaymentBilling(pay.paymentRef, 'DESTINATION')
                  }}
                />
              </div>
              <div className='row mt-2 m-0'>
                <div className={'col-8 p-0'}>
                  <label>Valor:</label>
                  <input
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark col-5'
                    value={formatMask(pay.amount)}
                    onChange={(e) => {
                      handleChangeValueMethodPaymentBilling(
                        index,
                        formatMask(e.target.value),
                        'DESTINATION'
                      )
                    }}
                  />
                </div>

                {pay.hasInstallment && (
                  <div className='col-4 p-0 ps-2'>
                    <label>N. Parcelas:</label>
                    <select
                      className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                      value={pay.installments}
                      onChange={(e) =>
                        handleChangeInstallmentsBilling(index, e.target.value, 'DESTINATION')
                      }
                    >
                      {optionInstallment?.map((val) => (
                        <option value={val}>{val}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
          )
        })
      )}
    </>
  )
}
